import { Enumeration } from './Enumeration';

/**
 * @typedef {Object} ResultErrorCode common error codes returned by API
 */
class ResultErrorCodeEnum extends Enumeration {
  Undefined = 0;
  SalesIdIsAlreadyUsed = 1;
  DuplicateExternalSalesCode = 2;
  SalesAgentWasNotFound = 3;
  SalesAgentHasNoSalesCodes = 4;
  SalesCodeAlreadyExpired = 5;
  RequiredFieldWasNotProvided = 6;
  UnknownBusinessArea = 7;
  SalesCodeWasNotFound = 8;
  SalesCodeNotBelongsToSalesAgent = 9;
  BusinessException = 10;
  HttpResponseException = 11;
  BankAccountInvalid = 12;
  TeamNotFound = 'TeamNotFound';
  DeepLinkIncorrect = 'DeepLinkIncorrect';
  RecursiveParentTeam = 'RecursiveParentTeam';
  AgentNotFound = 'AgentNotFound';
  EmployerNotFound = 'EmployerNotFound';

  constructor() {
    super();
    return Object.freeze(this);
  }
}

export const ResultErrorCode = new ResultErrorCodeEnum();
